import React from 'react'
import { OutletOption } from '../OutletSelectTypes'
import { AvailabilityBadge } from './AvailabilityBadge'

const hasOutletAvailability = (
  outlet: OutletOption
): outlet is OutletOption & { available: number } =>
  typeof outlet.available === 'number'

export const OutletSummary: React.FC<{
  outlet: OutletOption
  isListItem?: boolean
  showAvailability?: boolean
}> = ({ outlet, isListItem = false, showAvailability = true }) => (
  <span className="flex min-w-0 flex-1 items-center gap-2">
    <span className="min-w-0 flex-1">
      <span className="flex min-w-0 items-center gap-3 text-left typography-body-sm-emphasized text-neutral-default">
        <span className="min-w-0 truncate">{outlet.name}</span>
        {showAvailability && hasOutletAvailability(outlet) && (
          <AvailabilityBadge available={outlet.available} />
        )}
      </span>
      {isListItem && outlet.address && (
        <span className="mt-0.5 block truncate text-left typography-body-xs text-neutral-soft">
          {outlet.address}
        </span>
      )}
    </span>
  </span>
)
